import { Flex, Text } from '@mantine/core'

import { useIsResponsiveMobileView } from '@/hooks/responsive'

import CarouselButton from './CarouselButton'

interface CarouselControllerProps {
  title: string
  isPrevDisabled: boolean
  isNextDisabled: boolean
  onPrev: () => void
  onNext: () => void
  controllerVisible?: boolean
}

export default function CarouselController({
  title,
  isPrevDisabled,
  isNextDisabled,
  controllerVisible = true,
  onPrev,
  onNext,
}: CarouselControllerProps) {
  const isMobile = useIsResponsiveMobileView()
  return (
    <Flex justify="space-between" align="center" w="100%" mb={16} h={40}>
      <Text
        component="h2"
        variant={isMobile ? 'heading2' : 'heading1'}
        c="#fff"
        maw="calc(90% - 80px)"
      >
        {title}
      </Text>
      {controllerVisible && (
        <Flex align="center" gap={8}>
          <CarouselButton direction="prev" disabled={isPrevDisabled} onClick={onPrev} />
          <CarouselButton direction="next" disabled={isNextDisabled} onClick={onNext} />
        </Flex>
      )}
    </Flex>
  )
}
